<div class="navigator">
  <div class="showing-slot">
    <label class="showing" aria-live="polite">{{ 'showing' | translate:{from: paged.from || 0, to: paged.to || 0, total: paged.total || 0} }}</label>
  </div>
  <div class="links-slot">
    @if (paged.last_page > 1) {
      <nav class="links" [attr.aria-label]="'pager.nav' | translate">
        @if (navigators && paged.current_page > 1) {
          <button nbButton ghost status="basic" class="pager-first" shape="semi-round" size="small" [disabled]="disabled" [attr.aria-label]="'pager.previous' | translate" (click)="pageTo(paged.current_page - 1)">
            <nb-icon icon="arrow-ios-back"></nb-icon><span>{{ 'prev' | translate }}</span>
          </button>
        }
        @for (item of this.pagnater; track $index) {
          @if (item.isEllipsis) {
            <button nbButton ghost shape="semi-round" size="small" status="basic"
              [disabled]="disabled"
              (click)="pageTo(item.page)">...</button>
          } @else {
            <button nbButton shape="semi-round" size="small" ghost [status]="item.page == paged.current_page ? 'info' : 'basic'"
              [disabled]="disabled"
              [attr.aria-current]="item.page == paged.current_page ? 'page' : null"
              [attr.aria-label]="'page' | translate:{value: item.page}"
              (click)="pageTo(item.page)">{{ item.label }}</button>
          }
        }
        @if (navigators && paged.current_page < paged.last_page) {
          <button nbButton ghost status="basic" class="pager-last" shape="semi-round" size="small" [disabled]="disabled" [attr.aria-label]="'pager.next' | translate" (click)="pageTo(paged.current_page + 1)">
            <span>{{ 'next' | translate }}</span><nb-icon icon="arrow-ios-forward"></nb-icon>
          </button>
        }
      </nav>
    }
  </div>
  <div class="page-size-slot">
    @if (pageSize && pageSizeOptions?.length) {
      <div class="page-size">
        <span class="page-size-label">{{ 'perpage' | translate }}</span>
        <nb-select size="small" [optionsWidth]="50" fullWidth status="basic" [selected]="pageSize" [disabled]="disabled"
          (selectedChange)="onPageSizeSelected($event)" [attr.aria-label]="'perpage' | translate">
          @for (n of pageSizeOptions; track n) {
            <nb-option [value]="n">{{ n }}</nb-option>
          }
        </nb-select>
      </div>
    }
  </div>
</div>
